var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 20.75C6.12 20.75 1.75 16.38 1.75 11C1.75 5.62 6.12 1.25 11.5 1.25C16.88 1.25 21.25 5.62 21.25 11C21.25 16.38 16.88 20.75 11.5 20.75ZM11.5 2.75C6.95 2.75 3.25 6.45 3.25 11C3.25 15.55 6.95 19.25 11.5 19.25C16.05 19.25 19.75 15.55 19.75 11C19.75 6.45 16.05 2.75 11.5 2.75Z",
    fill: "#0033CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.66 22.79C20.58 22.79 20.5 22.78 20.43 22.77C19.96 22.71 19.11 22.39 18.63 20.96C18.38 20.21 18.47 19.46 18.88 18.89C19.29 18.32 19.98 18 20.77 18C21.79 18 22.59 18.39 22.95 19.08C23.31 19.77 23.21 20.65 22.64 21.5C21.93 22.57 21.16 22.79 20.66 22.79ZM20.06 20.49C20.23 21.01 20.47 21.27 20.63 21.29C20.79 21.31 21.09 21.12 21.4 20.67C21.69 20.24 21.71 19.93 21.64 19.79C21.57 19.65 21.29 19.5 20.77 19.5C20.46 19.5 20.23 19.6 20.1 19.77C19.98 19.94 19.96 20.2 20.06 20.49Z",
    fill: "#0033CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.f5b366fa49dbe60dfad359fd4ba502a5.svg";
export { ForwardRef as ReactComponent };